<template>
  <!-- Forms → 🔗. Since the post-op auto-send work this is no longer an 880px popup around the Tx Presenter editor: it mounts the
       full-screen "Procedure Forms & Post-op Instructions" editor (ProcedureFormsEditor), which owns its own chrome (scrim-less,
       full viewport), Escape handling, unsaved-changes prompt and loading. The component keeps its old name and props
       (`open`, `siteId`, `@close`) so FormsHome.vue's mount did not change. -->
  <procedure-forms-editor v-if="open" :site-id="siteId" :forms-settings="formsSettings" :initial-tab="initialTab" @close="$emit('close')" />
</template>

<script>
import ProcedureFormsEditor from './ProcedureFormsEditor/ProcedureFormsEditor.vue';

/**
 * Forms-side entry point for the per-site procedure-code → form map (consent form + post-op form + auto-send).
 *
 * The mapping is NOT Forms-specific: it lives in the `TX_PRESENTER_SETTINGS_CONSENT` blob, consumed by Tx Presenter's consent
 * bundling AND the Patient Profile "Get Form QR" table AND (new) the post-op sender. Tx Presenter → Settings → Consent keeps the
 * classic consent-only editor (SettingsConsent.vue) — same rows, same drop rule (utils/postOp/rows.js cleanRowsForSave), post-op
 * columns deliberately absent there ("Post-op only — edit in Forms").
 *
 * Plan: docs/plans/2026-10-15-post-op-auto-send-plan.md §5b.
 *
 * Forms Settings (release gate `formsSettings`, docs/plans/2026-10-20-forms-settings-plan.md D19): FormsHome passes `forms-settings` (and the tab to
 * open on, `initial-tab`) when the gate is on, and the same editor draws the four-tab Forms Settings screen. Both props default to today's behaviour.
 */
export default {
  name: 'ConsentMappingModal',
  components: { ProcedureFormsEditor },
  props: {
    open: { type: Boolean, default: false },
    siteId: { type: String, default: null },
    formsSettings: { type: Boolean, default: false },
    initialTab: { type: String, default: '' },
  },
};
</script>
